import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Button from '../../../../../components/Button';
import Legal from '../../../../Legal';

class DisclaimerDialog extends React.Component {
  state = {
      open: false,
      scroll: 'paper',
  };

  handleClickOpen = scroll => () => {
      this.setState({ open: true, scroll });
  };

  handleClose = () => {
      this.setState({ open: false });
  };

  render() {
      return (
          <div>
              <Button
                  onClick={this.handleClickOpen('paper')}
                  secondary
                  fullWidth
                  size="large"
                  color="primary"
                  variant="contained"
              >
                  Legal
              </Button>
              <Dialog
                  open={this.state.open}
                  onClose={this.handleClose}
                  scroll={this.state.scroll}
                  aria-labelledby="scroll-dialog-title"
              >
                  <DialogTitle id="scroll-dialog-title">Legal</DialogTitle>
                  <DialogContent>
                      <DialogContentText>
                          <Legal />
                      </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                      <Button onClick={this.handleClose} color="primary">
                          Close
                      </Button>
                  </DialogActions>
              </Dialog>
          </div>
      );
  }
}

export default DisclaimerDialog;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/DisclaimerDialog/DisclaimerDialog.js